import { useState } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
	const auth = useState('store', () => {
		return { store: {} }
	})

	function storeSet(key, value) {
		auth.value.store[key] = value

		return true
	}

	function storeGet(key) {
		if (auth.value.store[key] == undefined) {
			return null;
		}

		return auth.value.store[key]
	}

	return {
		provide: {
			storeGet, storeSet,
		}
	}
})